import { api } from "../api";
import { S, on, render } from "../state";
import { $, MONO, toast } from "../ui";
import type { MeResponse } from "../../shared/types";
import { photoBlock } from "./profile";
import { birthdayField, classOfField, collectProfile, interestsField, nameFields, phoneField } from "./fields";

/** First sign-in: the profile has to be finished before anything else. It can't be skipped. */
export function completionView() {
  const u = S.me!.user;
  return `<div class="signin"><div class="badge" style="width:100%;max-width:520px">
    <div class="bh">${MONO(52)}<div class="t">Miami Country Day School<small>Ambassador Scheduling</small></div></div>
    <div class="stripe"></div>
    <div class="bb"><form class="stack" data-submit="complete-profile" novalidate>
      <div><h2 style="margin-bottom:6px">Finish Your Profile</h2><p class="muted small" style="margin:0">Welcome! Please fill this in once before you get started.</p></div>
      ${photoBlock(true)}${nameFields(u)}${phoneField(u)}${birthdayField(u)}${classOfField(u, true)}${interestsField(u)}
      <div class="err" id="err" role="alert"></div>
      <div class="row wrap"><button class="btn" type="submit">Save and Continue</button><button class="btn ghost" type="button" data-act="signout">Sign Out</button></div>
    </form></div></div></div>`;
}

on({
  "complete-profile": async () => {
    const b = collectProfile();
    const err = (m: string) => (($("#err") as HTMLElement).textContent = m);
    if (!b.first || !b.last) return err("Enter your first and last name.");
    if ("classOf" in b && !b.classOf) return err("Enter your Class of year.");
    if ("interests" in b && !(b.interests as string[]).length) return err("Pick at least one event interest.");
    try {
      const r = await api<MeResponse & { missing: string[] }>("/api/me", { method: "PATCH", body: b });
      S.me = r;
      if (!r.user.profileComplete) return err(`Still needed: ${r.missing.join(", ")}.`);
      S.me = await api<MeResponse>("/api/me").catch(() => S.me);
      render();
      toast("Thanks! You're all set.");
    } catch (e) {
      err((e as Error).message);
    }
  },
});
